export default class Utils {}

Utils.isEmployer = (user) => {
  return user && user.role === "employer";
};

Utils.getUserToken = () => {
  return JSON.parse(localStorage.getItem("qcUserToken")) || "";
};

Utils.setUserToken = (token) => {
  localStorage.setItem("qcUserToken", JSON.stringify(token));
};

Utils.isApplicant = (user) => {
  return user && user.role === "applicant";
};

Utils.hasApplied = (user, job) => {
  return user && !!user.jobs.find((j) => j.title === job.title);
};

Utils.getCountryCode = (countries, country) => {
  return countries.find((c) => c.name === country)?.code;
};

Utils.isSignedIn = () => {
  return (
    localStorage.getItem("qcUserToken") &&
    localStorage.getItem("qcUserToken") !== "undefined"
  );
};

Utils.setCart = (cart) => {
  // store user in local storage
  localStorage.setItem("qcCart", JSON.stringify(cart));
};

Utils.getCart = () => {
  let data;
  try {
    data = JSON.parse(localStorage.getItem("qcCart")) || "{}";
  } catch (error) {
    data = {};
  }
  return data;
};

Utils.getSearchUrl = (keywords, location) => {
  let url = "/jobs";
  if (keywords || location) {
    url += "?";
    if (keywords) {
      url += `keywords=${keywords}`;
    }
    if (keywords && location) {
      url += "&";
    }
    if (location && location !== "") {
      url += `location=${location}`;
    }
  }
  return url;
};

Utils.getProfileSearchUrl = (keywords, location) => {
  let url = "/profiles";
  if (keywords || location) {
    url += "?";
    if (keywords) {
      url += `keywords=${keywords}`;
    }
    if (keywords && location) {
      url += "&";
    }
    if (location && location !== "") {
      url += `location=${location}`;
    }
  }
  return url;
};

Utils.constructSearchUrl = (keywords, location, options) => {
  const title = options && options.title ? String(options.title) : "";
  const city = options && options.city_in ? String(options.city_in) : "";
  const state = options && options.state_in ? String(options.state_in) : "";
  const country =
    options && options.country_in ? String(options.country_in) : "";
  const locations = location
    .split(",")
    .concat(city.split(","))
    .concat(state.split(","))
    .concat(country.split(","))
    .filter((l) => !!l);
  const titles = String(title.split(",").filter((w) => !!w));
  let url = `/profiles/search`;
  let values = [];
  if (titles) {
    values.push(`titles=${titles}`);
  }
  if (keywords) {
    values.push(`keywords=${keywords}`);
  }

  if (locations.length) {
    values.push(`locations=${locations}`);
  }

  if (values.length) {
    url += `?${values.join("&")}`;
  }

  return url;
};

Utils.stripHtml = (rawHtml) => {
  return rawHtml && rawHtml.replace(/(<\/?(?:a|p|br)[^>]*>)|<[^>]+>/gi, "$1");
};

Utils.stripHtmlForTeaser = (rawHtml) => {
  return rawHtml.replace(/(<\/?(?:a)[^>]*>)|<[^>]+>/gi, "$1");
};

Utils.uppercase = (string) => {
  let stringParts = string.split(" ");
  const newString = stringParts
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
  return newString;
};

Utils.currencyFormatter = (value, precision = 0) => {
  var formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: precision,
  });
  return formatter.format(value);
};

Utils.getDefaultProductOption = () => {
  return [{ display: "Purchase in Bulk and Save!", value: 0 }];
};

Utils.getProducts = () => {
  var products = [{ display: "Purchase in Bulk and Save!", value: 0 }];
  let cachedProducts = localStorage.getItem("p_data") || "[]";
  JSON.parse(cachedProducts).map((product, index) =>
    products.push({
      display: product.name,
      id: product.id,
      quantity: product.quantity,
      value: product.cost,
      details: product,
      created_at: product.created_at,
      description: product.description,
      sku: product.sku,
      updated_at: product.updated_at,
    })
  );

  products.push({ total: localStorage.getItem("_total"), value: 0 });
  return products;
};

Utils.getProductTotal = (productId, quantity = null) => {
  let total;
  const product = Utils.getProduct(productId);
  if (quantity) {
    total = product ? parseInt(quantity, 10) * parseInt(product.value, 10) : 0;
  } else {
    total = product
      ? parseInt(product.quantity, 10) * parseInt(product.value, 10)
      : 0;
  }
  return Utils.currencyFormatter(total, 2);
};

Utils.getProduct = (productId) => {
  return Utils.getProducts().filter(
    (product) => product.id === parseInt(productId, 10)
  )[0];
};

Utils.getProductByQuantity = (quantity) => {
  return Utils.getProducts().filter((product) => {
    return (
      product.quantity === parseInt(quantity, 10) ||
      (product.quantity >= 5 && parseInt(quantity, 10) >= 5)
    );
  })[0];
};

Utils.isJobOwner = (job) => {
  return parseInt(job.user_id, 10) === parseInt(Utils.getCurrentUser().id, 10);
};

// removes empty attributes with empty values
Utils.clean = (obj) => {
  for (var propName in obj) {
    var shouldDelete = obj[propName] === null || obj[propName] === undefined;
    shouldDelete = shouldDelete || obj[propName] === "";
    shouldDelete =
      shouldDelete ||
      (Array.isArray(obj[propName]) && obj[propName].length === 0);
    if (shouldDelete) {
      delete obj[propName];
    }
  }
  return obj;
};

Utils.resetJobsFilter = () => {
  localStorage.removeItem("jobFilters");
  var filterContainer = document.getElementById("jobs-filter");
  var checkboxes =
    filterContainer && filterContainer.getElementsByTagName("Input");
  checkboxes &&
    Array.from(checkboxes).forEach((input) => (input.checked = false));
};

Utils.convertToJSON = (data) => {
  return JSON.parse(
    JSON.stringify(data).replace(
      /(_\w)\w+":/g,
      (m) => m[1].toUpperCase() + m.substring(2)
    )
  );
};

Utils.convertToSnakeCase = (data) => {
  return JSON.parse(
    JSON.stringify(data).replace(
      /[\w]([A-Z])/g,
      (m) => m[0] + "_" + m[1].toLowerCase()
    )
  );
};

Utils.usStates = () => {
  return [
    {
      name: "Alabama",
      abbreviation: "AL",
    },
    {
      name: "Alaska",
      abbreviation: "AK",
    },
    {
      name: "American Samoa",
      abbreviation: "AS",
    },
    {
      name: "Arizona",
      abbreviation: "AZ",
    },
    {
      name: "Arkansas",
      abbreviation: "AR",
    },
    {
      name: "California",
      abbreviation: "CA",
    },
    {
      name: "Colorado",
      abbreviation: "CO",
    },
    {
      name: "Connecticut",
      abbreviation: "CT",
    },
    {
      name: "Delaware",
      abbreviation: "DE",
    },
    {
      name: "District Of Columbia",
      abbreviation: "DC",
    },
    {
      name: "Federated States Of Micronesia",
      abbreviation: "FM",
    },
    {
      name: "Florida",
      abbreviation: "FL",
    },
    {
      name: "Georgia",
      abbreviation: "GA",
    },
    {
      name: "Guam",
      abbreviation: "GU",
    },
    {
      name: "Hawaii",
      abbreviation: "HI",
    },
    {
      name: "Idaho",
      abbreviation: "ID",
    },
    {
      name: "Illinois",
      abbreviation: "IL",
    },
    {
      name: "Indiana",
      abbreviation: "IN",
    },
    {
      name: "Iowa",
      abbreviation: "IA",
    },
    {
      name: "Kansas",
      abbreviation: "KS",
    },
    {
      name: "Kentucky",
      abbreviation: "KY",
    },
    {
      name: "Louisiana",
      abbreviation: "LA",
    },
    {
      name: "Maine",
      abbreviation: "ME",
    },
    {
      name: "Marshall Islands",
      abbreviation: "MH",
    },
    {
      name: "Maryland",
      abbreviation: "MD",
    },
    {
      name: "Massachusetts",
      abbreviation: "MA",
    },
    {
      name: "Michigan",
      abbreviation: "MI",
    },
    {
      name: "Minnesota",
      abbreviation: "MN",
    },
    {
      name: "Mississippi",
      abbreviation: "MS",
    },
    {
      name: "Missouri",
      abbreviation: "MO",
    },
    {
      name: "Montana",
      abbreviation: "MT",
    },
    {
      name: "Nebraska",
      abbreviation: "NE",
    },
    {
      name: "Nevada",
      abbreviation: "NV",
    },
    {
      name: "New Hampshire",
      abbreviation: "NH",
    },
    {
      name: "New Jersey",
      abbreviation: "NJ",
    },
    {
      name: "New Mexico",
      abbreviation: "NM",
    },
    {
      name: "New York",
      abbreviation: "NY",
    },
    {
      name: "North Carolina",
      abbreviation: "NC",
    },
    {
      name: "North Dakota",
      abbreviation: "ND",
    },
    {
      name: "Northern Mariana Islands",
      abbreviation: "MP",
    },
    {
      name: "Ohio",
      abbreviation: "OH",
    },
    {
      name: "Oklahoma",
      abbreviation: "OK",
    },
    {
      name: "Oregon",
      abbreviation: "OR",
    },
    {
      name: "Palau",
      abbreviation: "PW",
    },
    {
      name: "Pennsylvania",
      abbreviation: "PA",
    },
    {
      name: "Puerto Rico",
      abbreviation: "PR",
    },
    {
      name: "Rhode Island",
      abbreviation: "RI",
    },
    {
      name: "South Carolina",
      abbreviation: "SC",
    },
    {
      name: "South Dakota",
      abbreviation: "SD",
    },
    {
      name: "Tennessee",
      abbreviation: "TN",
    },
    {
      name: "Texas",
      abbreviation: "TX",
    },
    {
      name: "Utah",
      abbreviation: "UT",
    },
    {
      name: "Vermont",
      abbreviation: "VT",
    },
    {
      name: "Virgin Islands",
      abbreviation: "VI",
    },
    {
      name: "Virginia",
      abbreviation: "VA",
    },
    {
      name: "Washington",
      abbreviation: "WA",
    },
    {
      name: "West Virginia",
      abbreviation: "WV",
    },
    {
      name: "Wisconsin",
      abbreviation: "WI",
    },
    {
      name: "Wyoming",
      abbreviation: "WY",
    },
  ];
};

Utils.countries = () => {
  return [
    {
      name: "United States",
      abbreviation: "US",
    },
  ];
};
